<template>
    <b-table
            id="cdasExecoes"
            :items="resultado"
            :fields="fields"
            striped
            small
            responsive="sm"
            :no-local-sorting="true"
            @sort-changed="sortingChanged"
            :busy="configTable.load"
            show-empty
    >
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>

        <template slot="empty">
            <p class="my-auto">Nenhum registro encontrado.</p>
        </template>

        <template slot="HEAD_selecionar">
            <b-form-checkbox v-model="configTable.checkedAll" class="mx-auto justify-content-center text-center ml-1" @change="toggleAll" />
        </template>
        <template slot="selecionar" slot-scope="row">
            <template>
                <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="row.item.checked" @change="toggleCheck($event, row.item, null, true)" />
            </template>
        </template>

        <template slot="1" slot-scope="row">
            <p class="text-left" :style="'min-width: 165px'">
                {{ row.item.tipoEvento.nome }}
            </p>
        </template>
        <template slot="2" slot-scope="row">
            <p class="text-left" :style="'min-width: 70px'">
                {{ row.item.numeroDivida }}
            </p>
        </template>
        <template slot="3" slot-scope="row">
            <p class="text-left" :style="'min-width: 90px'">
                {{ row.item.numeroCnpjRaiz }}
            </p>
        </template>
        <template slot="4" slot-scope="row">
            <p class="text-left" :style="'min-width: 80px'">
                {{ row.item.numeroCnpj }}
            </p>
        </template>
        <template slot="5" slot-scope="row">
            <p class="text-left" :style="'min-width: 80px'">
                {{ row.item.numeroCpf }}
            </p>
        </template>
        <template slot="6" slot-scope="row">
            <p class="text-left" :style="'min-width: 100px'">
                {{ row.item.nomeUsuarioInclusao || '-' }}
            </p>
        </template>
        <template slot="7" slot-scope="row" >
            <p class="text-left" v-if="row.item.dataHoraInclusao !== '2000-01-01 00:01:01.000'" :style="'min-width: 105px'">
                {{ formatarDataHora(row.item.dataHoraInclusao) }}
            </p>
            <p v-else :style="'min-width: 105px'">-</p>
        </template>
        <template slot="8" slot-scope="row">
            <p class="text-left" v-if="row.item.dataHoraInativacao !== '2000-01-01 00:01:01.000'" :style="'min-width: 120px'">
                {{ formatarDataHora(row.item.dataHoraInativacao) }}
            </p>
            <p v-else :style="'min-width: 120px'">-</p>
        </template>
        <template slot="9" slot-scope="row" >
            <p class="text-left" :style="'min-width: 90px'">
                {{ row.item.motivo }}
            </p>
        </template>
        
        <template slot="10" slot-scope="row">
            <p class="text-left" :style="'min-width: 90px'">
                {{ row.item.indAtivo ? 'Ativo' : 'Inativo' }}
            </p>
        </template>
    </b-table>
</template>

<script>
import formatarMixins from '../../mixins/formatarMixins'
    export default {
        mixins: [ formatarMixins ],
        props: ['resultado', 'fields', 'configTable','selecteds'],
        watch: {
            currentPage() {
                this.configTable.checkedAll = false
                this.$emit('consultar')
            }
        },
        computed: {
            currentPage() {
                return this.configTable.currentPage
            }
        },
        methods: {
            sortingChanged(ctx) {
                if(ctx.sortBy == 1) {
                    this.configTable.sortField = 'tipoEvento';
                }
                if(ctx.sortBy == 2) {
                    this.configTable.sortField = 'numeroDivida';
                }
                if(ctx.sortBy == 3) {
                    this.configTable.sortField = 'numeroCnpjRaiz';
                }
                if(ctx.sortBy == 4) {
                    this.configTable.sortField = 'numeroCnpj';
                }
                if(ctx.sortBy == 5) {
                    this.configTable.sortField = 'numeroCpf';
                }
                if(ctx.sortBy == 6) {
                    this.configTable.sortField = 'nomeUsuarioInclusao';
                }
                if(ctx.sortBy == 7) {
                    this.configTable.sortField = 'dataHoraInclusao';
                }
                if(ctx.sortBy == 8) {
                    this.configTable.sortField = 'dataHoraInativacao';
                }
                if(ctx.sortBy == 9) {
                    this.configTable.sortField = 'motivo';
                }
                if(ctx.sortBy == 10) {
                    this.configTable.sortField = 'indAtivo';
                }
                this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc';
                this.$emit('sortingChanged')
            },
            toggleAll(checked) {
                if(checked) {
                    this.resultado.forEach(el => {
                        el.checked = true;
                    if(!this.selecteds.includes(el.codExcecaoDevedor)) {
                        this.selecteds.push(el.codExcecaoDevedor);
                    }
                })
                } else {
                    this.resultado.forEach(el => {
                        el.checked = false;
                    if(this.selecteds.includes(el.codExcecaoDevedor)) {
                        const index = this.selecteds.indexOf(el.codExcecaoDevedor);
                        this.selecteds.splice(index, 1);
                    }
                })
                }
            },
            toggleCheck(checked, item) {
                if(checked) {
                    item.checked = checked;
                    this.selecteds.push(item.codExcecaoDevedor);
                } else {
                    item.checked = checked;
                    const index = this.selecteds.indexOf(item.codExcecaoDevedor);
                    this.selecteds.splice(index, 1);
                    this.configTable.checkedAll = false;
                }

            }
        }
    }
</script>

<style>
    th {
        text-align: center !important;
    }
</style>
